import { AB_TEST_REGISTRY } from '@/utils/abtest/abTestConfig'
import { useAbTest } from '@/composables/useAbTest'

export default defineNuxtPlugin(() => {
  const { initializeAll } = useAbTest()
  initializeAll(AB_TEST_REGISTRY)
})
